import React from 'react'
import { Flex, Text } from '@chilipiper/design-system'
import { Icon } from '@chilipiper/design-system/src/new'
import { IconError } from '@chilipiper/icons/figma-generated/src/icon'
import { ErrorBlock as ErrorBlockType } from '../../../chat-data/types'
import { useTranslations } from '../../../context/TranslationContext'

interface Props {
  block: ErrorBlockType
}

export const ErrorBlock = ({ block }: Props) => {
  const [errorOccurredText] = useTranslations(['errorOccurred'])
  return (
    <Flex
      p={4}
      bg='bg/section-emphasis'
      borderRadius={12}
      alignItems='flex-start'
      gap={3}
      data-test-id='ErrorBlock'
      w='100%'
    >
      <Icon icon={IconError} color='fg/caution' flexShrink={0} />
      <Flex flexDirection='column' gap={1} flexGrow={1}>
        <Text color='fg/caution' textStyle='body-multiline-tight' fontWeight='medium'>
          {errorOccurredText ?? 'Error occurred'}
        </Text>
        {block.message && (
          <Text color='fg/moderate' textStyle='body-multiline-tight'>
            {block.message}
          </Text>
        )}
      </Flex>
    </Flex>
  )
}
